"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findBestFee = findBestFee;
const module_logistic_interfaces_1 = require("@invivodf/module-logistic-interfaces");
const compute_retrocession_price_from_fee_1 = require("./compute-retrocession-price-from-fee");
function findBestFee(feesSchedule, quantity = 1, weightInGrams = 0, dimensionInMillimeters = 0) {
    if (!feesSchedule.length)
        return null;
    if (feesSchedule.length === 1)
        return feesSchedule[0];
    const weightFee = findFeeForRangeUnit(feesSchedule, module_logistic_interfaces_1.LogisticRangeUnit.WeightInG, weightInGrams);
    const dimensionFee = findFeeForRangeUnit(feesSchedule, module_logistic_interfaces_1.LogisticRangeUnit.DimensionInMm, dimensionInMillimeters);
    return computeBestFee(weightFee, dimensionFee, quantity, weightInGrams);
}
function findFeeForRangeUnit(feesSchedule, unit, value) {
    return (feesSchedule
        .filter(fee => { var _a; return (_a = fee.ranges) === null || _a === void 0 ? void 0 : _a.map(range => range.unit).includes(unit); })
        .find(fee => {
        var _a, _b, _c;
        if (!((_a = fee.ranges) === null || _a === void 0 ? void 0 : _a.length))
            return false;
        const end = (_c = (_b = fee.ranges.find(range => range.unit === unit)) === null || _b === void 0 ? void 0 : _b.end) !== null && _c !== void 0 ? _c : undefined;
        if (end) {
            return end >= value;
        }
        return true;
    }) || null);
}
function getPrice(fee, quantity, weightInGrams) {
    return fee ? (0, compute_retrocession_price_from_fee_1.computeRetrocessionPriceFromFee)(fee, quantity, weightInGrams) : undefined;
}
function computeBestFee(weightFee, dimensionFee, quantity, weightInGrams) {
    const weightPrice = getPrice(weightFee, quantity, weightInGrams);
    const dimensionPrice = getPrice(dimensionFee, quantity, weightInGrams);
    const bestPrice = getBestPrice(weightPrice, dimensionPrice);
    return bestPrice === weightPrice ? weightFee : dimensionFee;
}
function getBestPrice(priceWeight, priceDimension) {
    return toNumberOrInfinity(priceWeight) < toNumberOrInfinity(priceDimension)
        ? (priceWeight !== null && priceWeight !== void 0 ? priceWeight : '0')
        : (priceDimension !== null && priceDimension !== void 0 ? priceDimension : '0');
}
function toNumberOrInfinity(value) {
    return value ? +value : Infinity;
}
